import { ReactElement } from "react";
import { FormattedText, Typography } from "client/Components";
import { localize } from "client_legacy/ndaw/culture";

export const CommunityPostComposerPlaceholder = (): ReactElement => {
	return (
		<Typography textColor="secondary">
			<FormattedText
				text={localize("_PostComposerPlaceholder")}
				thingsToWrap={[
					{
						blockId: "PostContent",
						wrap: (x) => (
							<Typography
								isItalic
								weight="bold"
							>
								{x}
							</Typography>
						)
					},
				]}
			/>
		</Typography>
	);
};
CommunityPostComposerPlaceholder.displayName = "CommunityPostComposerPlaceholder";